import { correctionBuilder } from '../builders/correctionBuilder';
import { standardBuilder } from '../builders/standardBuilder';
import {
  QuestionDirector,
  QuestionDirectorFactory,
  QuestionViewMode,
} from '../types';
import { createDirector } from './createDirector';

const standardDirector = createDirector(standardBuilder);
const correctionDirector = createDirector(correctionBuilder);

const directors: Record<QuestionViewMode, QuestionDirector> = {
  answering: standardDirector,
  reviewing: standardDirector,
  correction: correctionDirector,
};

export const questionDirectorFactory: QuestionDirectorFactory = mode =>
  directors[mode];
